<template>
	<v-container grid-list-xl summaryReporting>
      <v-form >
        <center v-if="loading"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif"  /></center>
        <v-layout  row wrap v-else >
          <v-flex md3>
            <span class="sr-dates">
               <label class="blackLabel">Start Date</label>
              <date-picker id="dashDate" valueType="format" class="quoteDateRep dashDateRep" v-model="startDate_summary" placeholder="Summary Start Date" format="YYYY-MM-DD" lang="en" ></date-picker>
            </span>

            <span class="sr-dates">
               <label class="blackLabel">End Date <span class="grey--text">(cannot exceed 12 months)</span>
                 <!--              <v-tooltip left style="top: -3px !important;">-->
                 <!--              <i style="" slot="activator" class="material-icons">info</i>-->
                 <!--              <span>The date range selection cannot exceed 12 months</span>-->
                 <!--            </v-tooltip>-->
            </label>

              <!--            <small>-->
              <!--              <span>(12 months)</span>-->
              <!--              <v-tooltip left style="top: -3px !important;">-->
              <!--                <i style="display: inline-block; font-size: 16px;float: right; margin-right: 8px;" slot="activator" class="material-icons">info</i>-->
              <!--                <span>The date range selection cannot exceed 12 months</span>-->
              <!--              </v-tooltip>-->
              <!--            </small>-->
            <date-picker id="dashDate"  valueType="format" class="quoteDateRep dashDateRep input-error" @change="fncValidateDateRange($event)" v-model="endDate_summary" placeholder="Summary End Date" format="YYYY-MM-DD" lang="en"></date-picker>
            </span>

            <span class="sr-dates setdate">
              <label class="blackLabel"></label>
            <v-btn  color="info"  class="text-xs-right" style="float: left;display: block;top: 12px;" @click.stop="fnSetDate()">SET DATE</v-btn>
            </span>

          </v-flex>


        <v-flex md3 style="position:relative">
          <label class="mTop"><b>Status</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('status')">Done</a>
          <v-select ref="statusSelect" item-disabled="disable" prepend-icon="search" class="shortSelect" v-model="objStatus" :items="fncSetFiltersSummary('status')" item-text="name" item-value="id" multiple ou autocomplete @input="fncCheckDropdownsAllCheck('status')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'status')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'status')" class="grey--text caption">(+{{ objStatus.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
          <label class="mTop"><b>Service Type</b></label>
          <a class="filterDone" @click.stop="fncReloadFilters()" v-if="fncCheckDone('service_type')">Done</a>
          <v-select ref="serviceTypeSelect" class="shortSelect" prepend-icon="search" v-model="objServiceType" :items="fncSetFiltersSummary('service_type')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('service_type')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'service_type')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'service_type')" class="grey--text caption">(+{{ objServiceType.length - 1 }} others)
              </span>
            </template>
          </v-select>
        </v-flex>


        <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
          <label class="mTop"><b>Departments</b></label>
          <a class="filterDone" @click.stop="fncReloadFilters()" v-if="fncCheckDone('department')">Done</a>
          <v-select ref="departmentSelect" item-disabled="disable" prepend-icon="search" class="shortSelect" v-model="obj_Departments" :items="fncSetFiltersSummary('department')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('department')" >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'department')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'department')" class="grey--text caption">(+{{ obj_Departments.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>
          <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Vendor</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('vendor')">Done</a>
            <v-select ref="vendorSelect" class="shortSelect" v-model="objVendor" prepend-icon="search" :items="fncSetFiltersSummary('vendor')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdownsAllCheck('vendor')">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="displayChip(index, 'vendor')">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="displayText(index,'vendor')" class="grey--text caption">(+{{ objVendor.length - 1 }} others)</span>
              </template>
            </v-select>
          </v-flex>
        <v-flex md3 style="position:relative">
          <label class="mTop"><b>Roles</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('role')">Done</a>
          <v-select ref="roleSelect" item-disabled="disable" prepend-icon="search" class="shortSelect" v-model="role" :items="fncSetFiltersSummary('roles')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdownsAllCheck('roles')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'role')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'role')" class="grey--text caption">(+{{ role.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
          <label class="mTop"><b>Quote Type</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('quote_type')">Done</a>
          <v-select ref="quoteTypeSelect" class="shortSelect" prepend-icon="search" v-model="objQuoteType" :items="fncSetFiltersSummary('quote_type')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('quote_type')" >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'quote_type')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'quote_type')" class="grey--text caption">(+{{ objQuoteType.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>

        <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
          <label class="mTop"><b>Regions</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('region')">Done</a>
          <v-select ref="regionSelect" class="shortSelect" item-disabled="disable" prepend-icon="search" v-model="objRegion" :items="fncSetFiltersSummary('region')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('region')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'region')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'region')" class="grey--text caption">(+{{ objRegion.length - 1 }} others)
              </span>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
          <label class="mTop"><b>Store</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('store')">Done</a>
          <v-select prepend-icon="search"  :class="disableButton('store') ? 'shortSelect red_borders' : 'shortSelect' " ref="storeSelect" v-model="objStore" :items="fncSetFiltersSummary('store')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdownsAllCheck('store')" >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'store')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'store')" class="grey--text caption">(+{{ objStore.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
          <label class="mTop"><b>Responsible Rep</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('rep')">Done</a>
          <v-select ref="repSelect" class="shortSelect" prepend-icon="search" v-model="objRep" :items="fncSetFiltersSummary('rep')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('rep')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'rep')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'rep')" class="grey--text caption">(+{{ objRep.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 style="position:relative">
          <label class="mTop"><b>Originator</b></label>
          <a class="filterDone"  @click="fncReloadFilters()" v-if="fncCheckDone('originator')">Done</a>
          <v-select ref="originatorSelect" prepend-icon="search" class="shortSelect" v-model="objOriginator" :items="fncSetFiltersSummary('originator')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('originator')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'originator')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'originator')" class="grey--text caption">(+{{ objOriginator.length - 1 }} others)
              </span>
            </template>
          </v-select>
        </v-flex>

        <v-flex md3 style="position:relative">
          <label class="mTop"><b>Customer</b></label>
          <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('customer')">Done</a>
          <v-select ref="customerSelect" class="shortSelect" prepend-icon="search" v-model="objCustomerUser" :items="fncSetFiltersSummary('customer')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdownsAllCheck('customer')">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="displayChip(index, 'customer')">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="displayText(index,'customer')" class="grey--text caption">(+{{ objCustomerUser.length - 1 }} others)</span>
            </template>
          </v-select>
        </v-flex>
        <v-flex md3 style="position:relative" class="reporting-measurements">
          <label class="mTop"><b>Reporting Measurements</b></label>
          <v-select   class="shortSelect reportingDropdown" v-model="objMeasurement" :items="measurements" item-text="name" item-value="id"></v-select>
        </v-flex>
          <v-flex md3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative" class="reporting-category">
            <label class="mTop"><b>Category</b></label>
            <!--          <a class="filterDone" @click="fncReloadFilters()" style="top: 35px !important;right: 30px !important;" v-if="fncCheckDone('department')">Done</a>-->
            <v-select  class="shortSelect reportingDropdown" :value="objCategory" prepend-icon="search" :items="category" item-text="name" item-value="id" multiple autocomplete solo @change="fncCheckDropdowns('category', $event)">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span
                  v-if="index === 1 && objCategory[0] !== 'all'"
                  class="grey--text caption"
                >(+{{ objCategory.length - 1 }} others)
                </span>
              </template>
            </v-select>
          </v-flex>

        <v-flex md3 style="position:relative" class="reporting-increment">
          <label class="mTop"><b>Reporting Increment</b></label>
          <v-select   class="shortSelect reportingDropdown" v-model="objIncrement" :items="rep_increment" item-text="name" item-value="id"  ></v-select>
        </v-flex>


<!--          <v-flex xs4 class="miniSelect">-->
<!--            <label class="blackLabel">Departments</label>-->
<!--            <v-select @input="fncCheckAllDepartment" :items="objDepartments" item-value="id" item-text="name" label="Department" solo single-line v-model="department" autocomplete solo multiple></v-select><br />-->
<!--          </v-flex>-->
<!--          <v-flex xs4 class="miniSelect">-->
<!--            <label class="blackLabel">Status</label>-->
<!--            <v-select @input="fncCheckAllStatus" :disabled="disableDropDowns" :items="objStatus" item-value="id" item-text="name" label="Status" solo single-line v-model="status" autocomplete solo multiple></v-select><br />-->
<!--          </v-flex>-->

        <v-flex xs12>
          <hr>
        </v-flex>

        <v-flex md3 style="position:relative; margin-top: 5px; font-size: 16px;">
          <label class="mTop"><b>REPORT TYPE</b></label>
        </v-flex>

          <v-flex md4 class="d-flex" style="position:relative; margin-top: 5px; font-size: 16px;padding-left: 31px !important;">
            <div class="switch-container">
              <div class="left-label" v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1"><label> Origination </label></div>
              <v-switch v-model="value" v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1"  label="Conversions" @change="setModeDate" ></v-switch>
            </div>
          </v-flex>

          <v-flex md3 class="d-flex" style="position:relative; margin-top: 5px; font-size: 16px;">
            <v-switch v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" label="Show Zeros" style="float: right;display: block;margin-bottom: -20px !important;" v-model="show_zero"></v-switch>
          </v-flex>


          <v-flex md2 style="position:relative; float: right; margin-top: 5px;">
             <v-toolbar-side-icon v-if="!value"  :disabled="oldSummaryReport('summary')" style="float: right; margin-top: 0px"  color="white" right  @click.stop="drawer = !drawer"></v-toolbar-side-icon>


<!--          <v-navigation-drawer  mobile-break-point="10240" clipped fixed hide-overlay v-model="drawer" app style="padding-bottom: 0px !important; ::-webkit-scrollbar: width: 188px !important;">-->

          <v-navigation-drawer :disabled="oldSummaryReport('summary')" clipped bottom hide-overlay app style=" margin-top: 510px;width: 170px;margin-right: 50px;padding: 0px !important;height: auto !important;" right  v-if="drawer" v-model="drawer">
            <v-list >
              <div class="" >
                <v-list-tile  v-if="!oldSummaryReport('summary')"  >
                  <v-list-tile-content>
                    <v-list-tile-title   @click.stop="fncGenerateSummaryReport()"  style="cursor: pointer;">Resource Summary Report</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
            </v-list>
          </v-navigation-drawer>
        </v-flex>

        <v-flex md6  style="position:relative; text-align: center; display: none;">
          <label class="mTop" style="font-size: 15px"><b>Leads, Quotes and Sales by Origination Date</b></label>
        </v-flex>

        <v-flex md6 style="position:relative; text-align: center; display:none;" >
          <label  v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" class="mTop" style="font-size: 15px"><b >Sales by Conversion Date</b></label>
        </v-flex>

        <v-flex md5.7 class="align-end d-flex leadsButtons" style="position:relative; padding-top: 20px !important;">
          <v-tooltip :disabled=" ! ( newReportFilters.department && newReportFilters.department.length <= 0 || objCategory.length <= 0 || report_type == 2)"  top style="top: 0px !important;">
              <v-btn slot="activator"   class="elevation-4 " :disabled=" (newReportFilters.department.length <= 0 || objCategory.length <= 0 || report_type == 2) "   @click.stop="fncGenerate('department', 'Origination')" id="new_align" style="background-color: #333333 !important; min-width: 100px; width: 94%;height: 100px;border-radius: 10px!important; pointer-events: all !important;">
                <img align="center" class="report_image report_button" src="../../shared/assets/images/department_white.png"  />
                <label class="label_tile_top report_button">By</label>
                <label class="label_tile_bottom report_button">Department</label>
              </v-btn>
              <span v-if="report_type == 2">Currently on Conversion report</span>
              <span v-else>Department data missing</span>
          </v-tooltip>
          <v-tooltip :disabled=" !(newReportFilters.roles.store <= 0 || objCategory.length <= 0 || report_type == 2)"  top style="top: 0px !important;">
              <v-btn slot="activator" class="elevation-4" @click.stop="fncGenerate('store', 'Origination')" :disabled=" (newReportFilters.store.length <= 0 || objCategory.length <= 0 || report_type == 2)" id="new_align" style="background-color: #333333 !important;min-width: 100px; width: 94%;height: 100px;border-radius: 10px!important; pointer-events: all !important;">
                <img align="center" class="report_image report_button" src="../../shared/assets/images/region_white.png"  />
                <label class="label_tile_top report_button">By</label>
                <label class="label_tile_bottom report_button">Region/Store</label>
              </v-btn>
            <span v-if="report_type == 2">Currently on Conversion report</span>
            <span v-else>Region/Store data missing</span>
          </v-tooltip>
          <v-tooltip top :disabled="  !(newReportFilters.roles.length <= 0 || objCategory.length <= 0 || report_type == 2 || (show_zero && (obj_Departments[0] === 'all' || role[0] === 'all' )))" style="top: 0px !important;">
            <v-btn slot="activator" class="elevation-4 " :disabled=" (Object.keys(newReportFilters.roles).length <= 0 || objCategory.length <= 0 || report_type == 2 || (show_zero && (obj_Departments[0] === 'all' || role[0] === 'all' )))"  @click.stop="fncGenerate('role', 'Origination')"  id="new_align" style="background-color: #333333 !important;min-width: 100px; width: 94%;height: 100px;border-radius: 10px!important; pointer-events: all !important;">
              <img align="center" class="report_image report_button" src="../../shared/assets/images/role_white.png"  />
              <label class="label_tile_top report_button">By</label>
              <label class="label_tile_bottom report_button">Role</label>
            </v-btn>
              <span v-if="report_type == 2">Currently on Conversion report</span>
              <span v-else-if="show_zero">Please choose at least one department or role</span>
              <span v-else>Role data missing</span>
          </v-tooltip>
          <v-tooltip :disabled=" ! (newReportFilters.originator.length <= 0 || objCategory.length <= 0 || report_type == 2)" top style="top: 0px !important;">
              <v-btn slot="activator" class="elevation-4 " :disabled="(newReportFilters.originator.length <= 0 || objCategory.length <= 0 || report_type == 2)"  @click.stop="fncGenerate('originator', 'Origination')"  id="new_align" style="background-color: #333333 !important;min-width: 100px; width: 94%;height: 100px;border-radius: 10px!important; pointer-events: all !important; pointer-events: all !important;">
                <img align="center" class="report_image report_button" src="../../shared/assets/images/originator_white.png"  />
                <label class="label_tile_top report_button">By</label>
                <label class="label_tile_bottom report_button">Originator</label>
              </v-btn>
              <span v-if="report_type == 2">Currently on Conversion report</span>
              <span v-else>Originator data missing </span>
          </v-tooltip>
          <v-tooltip :disabled=" ! (newReportFilters.vendor.length <= 0 || objCategory.length <= 0 || report_type == 2)" top style="top: 0px !important;">
            <v-btn slot="activator" :disabled="(newReportFilters.vendor.length <= 0 || objCategory.length <= 0 || report_type == 2)" @click.stop="fncGenerate('vendor', 'Origination')"  class="elevation-4 " id="new_align" style="background-color: #333333 !important;min-width: 100px; width: 94%;height: 100px;border-radius: 10px!important; pointer-events: all !important;">
              <img align="center" class="report_image report_button" src="../../shared/assets/images/vendor_white.png"  />
              <label class="label_tile_top report_button">By</label>
              <label class="label_tile_bottom report_button">Vendor</label>
            </v-btn>
            <span v-if="report_type == 2">Currently on Conversion report</span>
            <span v-else>Vendor data missing </span>
          </v-tooltip>
        </v-flex>
          <v-flex md0.1 class="align-start d-flex" style="position:relative; padding-top: 0px !important;">
          </v-flex>

        <v-flex class="align-end d-flex salesButtons" md5.7 style="position:relative;padding-top: 20px !important;">
          <v-tooltip v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" :disabled=" !  (newReportFilters.department.length <= 0 || objCategory.length <= 0 || report_type == 1)"  top style="top: 0px !important;">
            <v-btn slot="activator"   class="elevation-4 second_btton_color" style="background-color: #ffd600 !important;min-width: 100px;width: 94%;height: 100px;border-radius: 10px!important;pointer-events: all !important;" :disabled=" (newReportFilters.department.length <= 0 || objCategory.length <= 0 || report_type == 1)" @click.stop="fncGenerate('department', 'conversion')" id="new_align" >
              <img align="center" class="report_image report_button" src="../../shared/assets/images/department_black.png"  />
              <label class="label_tile_top_conversion report_button">By</label>
              <label class="label_tile_bottom_conversion report_button">Department</label>
            </v-btn>
            <span v-if="report_type == 1">Currently on Origination report</span>
            <span v-else>Department data missing</span>
          </v-tooltip>
          <v-tooltip v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" :disabled=" !  (newReportFilters.store.length <= 0 || objCategory.length <= 0 || report_type == 1)"  top style="top: 0px !important;">
            <v-btn slot="activator" style="background-color: #ffd600 !important;min-width: 100px;width: 94%;height: 100px;border-radius: 10px!important;pointer-events: all !important;" class="elevation-4 second_btton_color" :disabled=" (newReportFilters.store.length <= 0 || objCategory.length <= 0 || report_type == 1)" @click.stop="fncGenerate('store', 'conversion')" id="new_align" >
              <img align="center" class="report_image report_button" src="../../shared/assets/images/region_black.png"  />
              <label class="label_tile_top_conversion report_button">By</label>
              <label class="label_tile_bottom_conversion report_button">Region/Store</label>
            </v-btn>
            <span v-if="report_type == 1">Currently on Origination report</span>
            <span v-else >Region/Store data missing</span>
          </v-tooltip>
          <v-tooltip v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" top :disabled=" ! (newReportFilters.roles.length <= 0 || objCategory.length <= 0 || report_type == 1 || (show_zero && (obj_Departments[0] === 'all' || role[0] === 'all')))" style="top: 0px !important;">
            <v-btn slot="activator" style="background-color: #ffd600 !important;min-width: 100px;width: 94%;height: 100px;border-radius: 10px!important;pointer-events: all !important;" class="elevation-4 second_btton_color" :disabled=" (newReportFilters.roles.length <= 0 || objCategory.length <= 0 || report_type == 1 || (show_zero && (obj_Departments[0] === 'all' || role[0] === 'all')))" @click.stop="fncGenerate('role', 'conversion')" id="new_align">
              <img align="center" class="report_image report_button" src="../../shared/assets/images/role_black.png"  />
              <label class="label_tile_top_conversion report_button">By</label>
              <label class="label_tile_bottom_conversion report_button">Role</label>
            </v-btn>
            <span v-if="report_type == 1">Currently on Origination report</span>
            <span v-else-if="show_zero">Please choose at least one department or role</span>
            <span v-else >Role data missing</span>
          </v-tooltip>
          <v-tooltip v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" :disabled=" ! (newReportFilters.originator.length <= 0 || objCategory.length <= 0 || report_type == 1)" top style="top: 0px !important;">
            <v-btn slot="activator" style="background-color: #ffd600 !important;min-width: 100px;width: 94%;height: 100px;border-radius: 10px!important;pointer-events: all !important;" class="elevation-4 second_btton_color" :disabled="(newReportFilters.originator.length <= 0 || objCategory.length <= 0 || report_type == 1)" @click.stop="fncGenerate('originator', 'conversion')"  id="new_align" >
              <img align="center" class="report_image report_button" src="../../shared/assets/images/originator_black.png"  />
              <label class="label_tile_top_conversion report_button">By</label>
              <label class="label_tile_bottom_conversion report_button">Originator</label>
            </v-btn>
            <span v-if="report_type == 1">Currently on Origination report</span>
            <span v-else>Originator data missing </span>
          </v-tooltip>
          <v-tooltip v-if=" objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1" :disabled=" ! (newReportFilters.vendor.length <= 0 || objCategory.length <= 0 || report_type == 1)" top style="top: 0px !important;">
            <v-btn slot="activator" style="background-color: #ffd600 !important;min-width: 100px;width: 94%;height: 100px;border-radius: 10px!important;pointer-events: all !important;" :disabled=" (newReportFilters.vendor.length <= 0 || objCategory.length <= 0 || report_type == 1)" @click.stop="fncGenerate('vendor', 'conversion')"  class="elevation-4 second_btton_color" id="new_align" >
              <img align="center" class="report_image report_button" src="../../shared/assets/images/vendor_black.png"  />
              <label class="label_tile_top_conversion report_button ">By</label>
              <label class="label_tile_bottom_conversion report_button">Vendor</label>
            </v-btn>
            <span v-if="report_type == 1">Currently on Origination report</span>
            <span v-else>Vendor data missing </span>
          </v-tooltip>

<!--          <v-btn class="elevation-4 " id="new_align" style="background-color: #ffd600;min-width: 100px; width: 18%;height: 160px;border-radius: 10px!important;">-->
<!--            <img align="center" class="report_image report_button" src="../../shared/assets/images/department_black.png"  />-->
<!--            <label class="label_tile_top_conversion report_button">By</label>-->
<!--            <label class="label_tile_bottom_conversion report_button">Department</label>-->
<!--          </v-btn>-->
<!--          <v-btn class="elevation-4 " id="new_align" style="background-color: #ffd600!important;min-width: 100px; width: 18%;height: 100px;border-radius: 10px!important;">-->
<!--            <img align="center" class="report_image report_button" src="../../shared/assets/images/region_black.png"  />-->
<!--            <label class="label_tile_top_conversion report_button">By</label>-->
<!--            <label class="label_tile_bottom_conversion report_button">Region/Store</label>-->
<!--          </v-btn>-->
<!--          <v-btn class="elevation-4 " id="new_align" style="background-color: #ffd600;min-width: 100px; width: 18%;height: 100px;border-radius: 10px!important;">-->
<!--            <img align="center" class="report_image report_button" src="../../shared/assets/images/role_black.png"  />-->
<!--            <label class="label_tile_top_conversion report_button">By</label>-->
<!--            <label class="label_tile_bottom_conversion report_button">Role</label>-->
<!--          </v-btn>-->
<!--          <v-btn class="elevation-4 " id="new_align" style="background-color: #ffd600;min-width: 100px; width: 18%;height: 100px;border-radius: 10px!important;">-->
<!--            <img align="center" class="report_image report_button" src="../../shared/assets/images/originator_black.png"  />-->
<!--            <label class="label_tile_top_conversion report_button">By</label>-->
<!--            <label class="label_tile_bottom_conversion report_button">Originator</label>-->
<!--          </v-btn>-->
<!--          <v-btn class="elevation-4 " id="new_align" style="background-color: #ffd600;min-width: 100px; width: 18%;height: 100px;border-radius: 10px!important;">-->
<!--            <img align="center" class="report_image report_button" src="../../shared/assets/images/vendor_black.png"  />-->
<!--            <label class="label_tile_top_conversion report_button">By</label>-->
<!--            <label class="label_tile_bottom_conversion report_button">Vendor</label>-->
<!--          </v-btn>-->
        </v-flex>

<!--        <v-flex xs6>-->
<!--          <small style="display: block;text-align: right; clear:both;font-size: 10px;" v-if="fncCheckFilters()">Please ensure atleast one department, status and role is selected.</small>-->
<!--          <v-progress-circular indeterminate style="margin-top:12px;margin-left:20px;" :width="3" :size="20" v-if="summaryLoading == true" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
<!--          <v-btn v-if="summaryLoading != true" :disabled="fncCheckFilters()" color="info" class="text-xs-right" style="float: right;" @click.stop="fncGenerate()">Generate Export</v-btn>-->
<!--          <v-btn color="info" class="text-xs-right cancelButton" style="float: right;" @click.stop="fncClearAll()">Clear</v-btn>-->
<!--        </v-flex>-->
          <!--<v-data-table style="margin-top: 0px;" v-if="loading == false" :search="search" :headers="headers" :items="responsibleReps" hide-actions class="elevation-1 repLinkTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
            <template slot="items" slot-scope="props">
              <td width="15%"><v-switch @change="fncSaveResponsibleRep( props.item )" v-model="props.item.checked"></v-switch></td>
              <td width="45%" v-html="fncExtractData(props.item.name, 0)"></td>
              <td width="40%" v-html="fncExtractData(props.item.name, 1)"></td>
            </template>
          </v-data-table>-->


        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
            <v-btn color="info" class="text-xs-right cancelButton" style="float: right;" @click.stop="fncClearFilter()">CLEAR FILTERS</v-btn>
          </div>
        </div>
</v-layout>
      </v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
  import DatePicker from 'vue2-datepicker';

	export default {
	  name: 'Settings',
	  data () {
			return {
        value:  window.localStorage.summaryReportReportType != undefined && window.localStorage.summaryReportReportType != null ? JSON.parse(window.localStorage.summaryReportReportType) : false,
        leftLabel: 'Label Left',
        rightLabel: 'Label Right',
        report_type:  (window.localStorage.summaryReportReportType != undefined && window.localStorage.summaryReportReportType != null && window.localStorage.summaryReportReportType === 'true') ? 2: 1,
        color: 'primary',
        dept_disable: true,
        status_disable: true,
        vendor_disable: true,
        roles_disable: true,
        quote_type_disable: true,
        region_disable: true,
        store_disable: true,
        rep_disable: true,
        originator_disable: true,
        service_type_disabled: true,
        show_zero: false,
        customerClickChanged: false,
        deptChanged: false,
        roleChanged: false,
        statusChanged: false,
        serviceTypeChanged: false,
        quoteTypeChanged: false,
        regionChanged: false,
        storesChanged: false,
        repChanged: false,
        originatorChanged: false,
        vendorChanged: false,
        customerChanged: false,
        prevDept: [],
        increment: 1,
        regenFalse: true,
        drawer: false,
        measurements:[
          {id: 1, name: 'Value'},
          {id: 2, name: 'Count'}
        ],
        rep_increment:[{
          id:1, name: 'Monthly'
        },
          {
            id: 2, name: 'Whole Period'
          }],
        category: [
          {id: 'all', name: 'All'},
          {id:1, name: 'Leads'},
          {id:2, name: 'Quotes'},
          {id:3, name: 'Sales'}
          ,{id: 4, name: 'Cancelled'}
        ],
        roleRules: [
          v => !!v.filter(element => element !== 'all') || 'Region name is required',
          ],
        startDate_summary: '',
        endDate_summary: '',
        department: '',
        status: '',
        objRoles: [],
			  loading: true,
        disableDropDowns: true,
        role: window.localStorage.summaryReportRoles != undefined && window.localStorage.summaryReportRoles != null ? JSON.parse(window.localStorage.summaryReportRoles) : ['all'],
        objStatus: window.localStorage.summaryReportStatus != undefined && window.localStorage.summaryReportStatus != null ? JSON.parse(window.localStorage.summaryReportStatus) : ['all'],
        objVendor: window.localStorage.summaryReportVendors != undefined && window.localStorage.summaryReportVendors != null ? JSON.parse(window.localStorage.summaryReportVendors) :['all'],
        obj_Departments: window.localStorage.summaryReportDepartments != undefined && window.localStorage.summaryReportDepartments != null ? JSON.parse(window.localStorage.summaryReportDepartments) : ['all'],
        objCustomerRegion: window.localStorage.summaryReportRegion != undefined && window.localStorage.summaryReportRegion != null ? JSON.parse(window.localStorage.summaryReportRegion ): [],
        objOriginator: window.localStorage.summaryReporteportOriginators != undefined && window.localStorage.summaryReporteportOriginators != null ? JSON.parse(window.localStorage.summaryReporteportOriginators) : ['all'],
        objKam: window.localStorage.summaryReportKams != undefined && window.localStorage.summaryReportKams != null ? JSON.parse(window.localStorage.summaryReportKams) : ['all'],
        objcOriginator: window.localStorage.summaryReportcOriginator != undefined && window.localStorage.summaryReportcOriginator != null ? JSON.parse(window.localStorage.summaryReportcOriginator) : ['all'],
        objQuoteType: window.localStorage.summaryReportQuoteType != undefined && window.localStorage.summaryReportQuoteType != null ? JSON.parse(window.localStorage.summaryReportQuoteType) : ['all'],
        objServiceType: window.localStorage.summaryReportServiceType != undefined && window.localStorage.summaryReportServiceType != null ? JSON.parse(window.localStorage.summaryReportServiceType) : ['all'],
        objRegions: window.localStorage.summaryReportRegions != undefined && window.localStorage.summaryReportRegions != null ? JSON.parse(window.localStorage.summaryReportRegions) : ['all'],
        objCategory: window.localStorage.summaryReportCategory != undefined && window.localStorage.summaryReportCategory != null ? JSON.parse(window.localStorage.summaryReportCategory) : ['all'],
        objRegion: window.localStorage.summaryReportRegion != undefined && window.localStorage.summaryReportRegion != null ? JSON.parse(window.localStorage.summaryReportRegion) : ['all'],
        objStore: window.localStorage.summaryReportStore != undefined && window.localStorage.summaryReportStore != null ? JSON.parse(window.localStorage.summaryReportStore) : ['all'],
        objRep: window.localStorage.summaryReportRep != undefined && window.localStorage.summaryReportRep != null ? JSON.parse(window.localStorage.summaryReportRep) : ['all'],
        objMeasurement: window.localStorage.summaryReportMeasurement != undefined && window.localStorage.summaryReportMeasurement != null ? JSON.parse(window.localStorage.summaryReportMeasurement) : 1,
        objIncrement: window.localStorage.summaryReportIncrement != undefined && window.localStorage.summaryReportIncrement != null ? JSON.parse(window.localStorage.summaryReportIncrement) : 1,
        objCustomerUser: window.localStorage.summaryReportCustomerUser != undefined && window.localStorage.summaryReportCustomerUser != null ? JSON.parse(window.localStorage.summaryReportCustomerUser) : ['all'],
      };
		},
		methods: {
      btnSearch(){

        this.dept_disable = !this.dept_disable
      },
      disableProp(items)
      {
        //console.log('items ' + items)
      },
      displayChip(index, type){

          if (type === 'status' && this.newReportFilters.hasOwnProperty('status')) {
            if (index === 0 && this.objStatus.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.status).length === this.getallFilters.filters.status[0].status) {
              return true
            } else if (index === 1 && this.objStatus[0] === 'all' && Object.keys(this.newReportFilters.status).length !== this.getallFilters.filters.status[0].status) {
              return true
            } else if (index === 0 && this.objStatus[0] !== 'all' && Object.keys(this.newReportFilters.status).length !== this.getallFilters.filters.status[0].status) {
              return true
            } else
              return false
          }
          if (type === 'originator') {
            if (index === 0 && this.objOriginator.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.originator).length === this.getallFilters.filters.originator[0].originator) {
              return true
            } else if (index === 1 && this.objOriginator[0] === 'all' && Object.keys(this.newReportFilters.originator).length !== this.getallFilters.filters.originator[0].originator) {
              return true
            } else if (index === 0 && this.objOriginator[0] !== 'all' && Object.keys(this.newReportFilters.originator).length !== this.getallFilters.filters.originator[0].originator) {
              return true
            } else
              return false
          }
          if (type === 'service_type') {
            if (index === 0 && this.objServiceType.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.service_type).length === 3) {
              return true
            } else if (index === 1 && this.objServiceType[0] === 'all' && Object.keys(this.newReportFilters.service_type).length !== 3) {
              return true
            } else if (index === 0 && this.objServiceType[0] !== 'all' && Object.keys(this.newReportFilters.service_type).length !== 3) {
              return true
            } else
              return false
          }
          if (type === 'department' && this.newReportFilters.hasOwnProperty('department')) {
            if (index === 0 && this.obj_Departments.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.department).length === this.getallFilters.filters.dept[0].department) {
              return true
            } else if (index === 1 && this.obj_Departments[0] === 'all' && Object.keys(this.newReportFilters.department).length !== this.getallFilters.filters.dept[0].department) {
              return true
            } else if (index === 0 && this.obj_Departments[0] !== 'all' && Object.keys(this.newReportFilters.status).length !== this.getallFilters.filters.dept[0].department) {
              return true
            } else
              return false
          }
          if (type === 'vendor' && this.newReportFilters.hasOwnProperty('vendor') ) {
            if (index === 0 && this.objVendor.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.vendor).length === this.getallFilters.filters.vendor[0].vendor) {
              return true
            } else if (index === 1 && this.objVendor[0] === 'all' && Object.keys(this.newReportFilters.vendor).length !== this.getallFilters.filters.vendor[0].vendor) {
              return true
            } else if (index === 0 && this.objVendor[0] !== 'all' && Object.keys(this.newReportFilters.vendor).length !== this.getallFilters.filters.vendor[0].vendor) {
              return true
            } else
              return false
          }
          if (type === 'quote_type') {
            if (index === 0 && this.objQuoteType.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.quote_type).length === 3) {
              return true
            } else if (index === 1 && this.objQuoteType[0] === 'all' && Object.keys(this.newReportFilters.quote_type).length !== 3) {
              return true
            } else if (index === 0 && this.objQuoteType[0] === 'all' && Object.keys(this.newReportFilters.quote_type).length !== 3) {
              return true
            } else if (index === 0 && this.objQuoteType[0] !== 'all' && Object.keys(this.newReportFilters.quote_type).length !== 3) {
              return true
            } else
              return false
          }
          if (type === 'quote_type') {
            if (index === 0 && this.objVendor.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.quote_type).length === 3) {
              return true
            } else if (index === 1 && this.objVendor[0] === 'all' && Object.keys(this.newReportFilters.quote_type).length !== 3) {
              return true
            } else if (index === 0 && this.objVendor[0] !== 'all' && Object.keys(this.newReportFilters.quote_type).length !== 3) {
              return true
            } else
              return false
          }
          if (type === 'store') {
            if (index === 0 && this.objStore.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.store).length === this.getallFilters.filters.store[0].store) {
              return true
            } else if (index === 1 && this.objStore[0] === 'all' && Object.keys(this.newReportFilters.store).length !== this.getallFilters.filters.store[0].store) {
              return true
            } else if (index === 0 && this.objStore[0] !== 'all' && Object.keys(this.newReportFilters.store).length !== this.getallFilters.filters.store[0].store) {
              return true
            } else
              return false
          }
          if (type === 'rep') {
            if (index === 0 && this.objRep.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.reps).length === this.getallFilters.filters.rep[0].rep) {
              return true
            } else if (index === 1 && this.objRep[0] === 'all' && Object.keys(this.newReportFilters.reps).length !== this.getallFilters.filters.rep[0].rep) {
              return true
            } else if (index === 0 && this.objRep[0] !== 'all' && Object.keys(this.newReportFilters.reps).length !== this.getallFilters.filters.rep[0].rep) {
              return true
            } else
              return false
          }
          if (type === 'region') {
            if (index === 0 && this.objRegion.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.regions).length === this.getallFilters.filters.region[0].region) {

              return true
            } else if (index === 1 && this.objRegion[0] === 'all' && Object.keys(this.newReportFilters.regions).length !== this.getallFilters.filters.region[0].region) {
              return true
            } else if (index === 0 && this.objRegion[0] !== 'all' && Object.keys(this.newReportFilters.regions).length !== this.getallFilters.filters.region[0].region) {
              return true
            } else
              return false
          }
          if (type === 'customer') {
            if (index === 0 && this.objCustomerUser.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.customer).length === this.getallFilters.filters.customer[0].company) {
              return true
            } else if (index === 1 && this.objCustomerUser[0] === 'all' && Object.keys(this.newReportFilters.customer).length !== this.getallFilters.filters.customer[0].company) {
              return true
            } else if (index === 0 && this.objCustomerUser[0] !== 'all' && Object.keys(this.newReportFilters.customer).length !== this.getallFilters.filters.customer[0].company) {
              return true
            } else
              return false
          }
          if (type === 'role') {
            if (index === 0 && this.role.length > 0) {
              return true
            } else if (index === 0 && Object.keys(this.newReportFilters.customer).length === this.getallFilters.filters.role[0].role) {
              return true
            } else if (index === 1 && this.role[0] === 'all' && Object.keys(this.newReportFilters.roles).length !== this.getallFilters.filters.role[0].role) {
              return true
            } else if (index === 0 && this.role[0] !== 'all' && Object.keys(this.newReportFilters.roles).length !== this.getallFilters.filters.role[0].role) {
              return true
            } else
              return false
          }

      },
      displayText(index, type){
        if (type === 'status'){
          if (index === 1 && this.objStatus[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.status).length !== this.getallFilters.filters.status[0].status){
            return true
          }
          else
            return false
        }
        if (type === 'region'){
          if (index === 1 && this.objRegion[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.regions).length !== this.getallFilters.filters.region[0].region){
            return true
          }
          else
            return false
        }
        if (type === 'originator'){
          if (index === 1 && this.objOriginator[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.originator).length !== this.getallFilters.filters.originator[0].originator){
            return true
          }
          else
            return false
        }
        if (type === 'service_type'){
          if (index === 1 && this.objServiceType[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.service_type).length !== 3){
            return true
          }
          else
            return false
        }
        if (type === 'department'){
          if (index === 1 && this.obj_Departments[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.department).length !== this.getallFilters.filters.dept[0].department){
            return true
          }
          else
            return false
        }
        if (type === 'vendor'){
          if (index === 1 && this.objVendor[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.vendor).length !== this.getallFilters.filters.vendor[0].vendor){
            return true
          }
          else
            return false
        }
        if (type === 'quote_type'){
          if (index === 1 && this.objServiceType[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.quote_type).length !== 3){
            return true
          }
          else
            return false
        }
        if (type === 'store'){
          if (index === 1 && this.objStore[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.store).length !== this.getallFilters.filters.store[0].store){
            return true
          }
          else
            return false
        }
        if (type === 'rep'){
          if (index === 1 && this.objRep[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.reps).length !== this.getallFilters.filters.rep[0].rep){
            return true
          }
          else
            return false
        }
        if (type === 'customer'){
          if (index === 1 && this.objCustomerUser[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.customer).length !== this.getallFilters.filters.customer[0].company){
            return true
          }
          else
            return false
        }
        if (type === 'role'){
          if (index === 1 && this.objCustomerUser[0] !== 'all'){
            return true
          }
          else if (index === 1 && Object.keys(this.newReportFilters.roles).length !== this.getallFilters.filters.role[0].role){
            return true
          }
          else
            return false
        }

      },
      monthDiff(d1, d2) {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth()+1;
        return months <= 0 ? 0 : months;
      },
      fncClearFilter() {
        this.objVendor = ['all'];
        this.obj_Departments = ['all'];
        this.objStore = ['all'];
        this.objOriginator = ['all'];
        this.objCustomerUser = ['all'];
        this.objStatus = ['all'];
        this.objRegions = ['all'];
        this.objRep = ['all'];
        this.objKam = ['all'];
        this.objQuoteType = ['all'];
        this.objServiceType = ['all'];
        this.objcOriginator = ['all'];
        this.objProjects = ['all'];
        this.objCompany = ['all'];
        this.objRegion = ['all'];
        this.objRoles = ['all'];
        this.role = ['all'];

        this.deptChanged = false
        this.statusChanged = false
        this.serviceTypeChanged = false
        this.quoteTypeChanged = false
        this.regionChanged = false
        this.storesChanged = false
        this.repChanged = false
        this.originatorChanged = false
        this.vendorChanged = false
        this.customerChanged = false
        this.customerClickChanged = false
        this.roleChanged = false


        // if (this.roleChanged){
        //   if (localStorage.getItem('summaryReportRoles') === this.role){
        //       localStorage.setItem('summaryReportRoles', JSON.stringify( this.role))

        // localStorage.removeItem('summary_status' )
        // localStorage.removeItem('summary_roles')
        // localStorage.removeItem('summaryReportDepartments')
        // localStorage.removeItem('summaryReportCategory')
        // localStorage.removeItem('summaryReportStatus')
        // localStorage.removeItem('summaryReportVendors')
        // localStorage.removeItem('summaryReportRegion')
        // localStorage.removeItem('summaryReporteportOriginators')
        // localStorage.removeItem('summaryReportKams')
        // localStorage.removeItem('summaryReportcOriginator')
        // localStorage.removeItem('summaryReportQuoteType')
        // localStorage.removeItem('summaryReportServiceType')
        // localStorage.removeItem('summaryReportRegion')
        // localStorage.removeItem('summaryReportStore')
        // localStorage.removeItem('summaryReportRep')
        // localStorage.removeItem('summaryReportMeasurement')
        // localStorage.removeItem('summaryReportRoles')
        // if (this.roleChanged){
        //   if (localStorage.getItem('summaryReportRoles') === this.role){
        //       localStorage.setItem('summaryReportRoles', JSON.stringify( this.role))
        //   }
        // }
        // else
        //   this.role = JSON.parse(localStorage.getItem('summaryReportRoles'))

        this.fncReloadFilters();

        // setTimeout(() => {
        //   localStorage.setItem('summary_status', JSON.stringify(this.status))
        //   localStorage.setItem('summary_roles', JSON.stringify(this.role))
        //   localStorage.setItem('summaryReportDepartments', JSON.stringify( this.obj_Departments))
        //   localStorage.setItem('summaryReportCategory', JSON.stringify( this.objCategory))
        //   localStorage.setItem('summaryReportStatus', JSON.stringify( this.objStatus))
        //   localStorage.setItem('summaryReportVendors', JSON.stringify( this.objVendor))
        //   localStorage.setItem('summaryReportRegion', JSON.stringify( this.objCustomerRegion))
        //   localStorage.setItem('summaryReporteportOriginators', JSON.stringify( this.objOriginator))
        //   localStorage.setItem('summaryReportKams', JSON.stringify( this.objKam))
        //   localStorage.setItem('summaryReportcOriginator', JSON.stringify( this.objcOriginator))
        //   localStorage.setItem('summaryReportQuoteType', JSON.stringify( this.objQuoteType))
        //   localStorage.setItem('summaryReportServiceType', JSON.stringify( this.objServiceType))
        //   localStorage.setItem('summaryReportRegion', JSON.stringify( this.objRegion))
        //   localStorage.setItem('summaryReportStore', JSON.stringify( this.objStore))
        //   localStorage.setItem('summaryReportRep', JSON.stringify( this.objRep))
        //   localStorage.setItem('summaryReportMeasurement', JSON.stringify( this.objMeasurement))
        //   localStorage.setItem('summaryReportRoles', JSON.stringify( this.role))
        // }, 4000)
      },
      oldSummaryReport(type)
      {
        if (type === 'summary') {
          if (this.value) {
            return true
          }


          let dept = this.newReportFilters.department;
          let status = this.newReportFilters.status;
          let array = this.newReportFilters.roles;
          if (array && Object.keys(array).length > 0 && dept && Object.keys(dept).length > 0 && status && Object.keys(status).length > 0) {
            return false;
          }
        }
        else
          return true
      },
      disableButton(type){
        let isObjectEmpty = (object) => {
          return Object.keys(this.newReportFilters).length === 0;
        }
        if (! isObjectEmpty) {
          if ((this.startDate_summary != null && this.startDate_summary !== undefined) && (this.endDate_summary != null && this.endDate_summary !== undefined)) {
            if (type === 'department') {
              let array = this.newReportFilters.department;
              if (Object.keys(array).length > 0 && this.objCategory.length > 0) {
                return false
              } else
                return true
            }
            if (type === 'store') {
              let array = this.newReportFilters.store;
              let reg = this.newReportFilters.region;
              if ((Object.keys(array).length > 0) && this.objCategory.length > 0) {
                return false
              } else
                return true
            }
            if (type === 'role') {
              let array = this.newReportFilters.roles;
              if (array.length > 0 || this.objCategory.length > 0) {
                let array = this.newReportFilters.roles;
                if (Object.keys(array).length > 0 && this.objCategory.length > 0) {
                  return false
                } else
                  return true
              }
            }
              if (type === 'originator') {
                let array = this.newReportFilters.originator;
                if (Object.keys(array).length > 0 && this.objCategory.length > 0) {
                  return false
                } else
                  return true
              }
              if (type === 'vendor') {
                let array = this.newReportFilters.vendor;
                if (Object.keys(array).length > 0 && this.objCategory.length > 0) {
                  return false
                } else
                  return true
              }
              if (type === 'summary') {
                if (this.value){
                  console.log('hereerere')
                  return true
                }


                let dept = this.newReportFilters.department;
                let status = this.newReportFilters.status;
                let array = this.newReportFilters.roles;
                if (Object.keys(array).length > 0 && Object.keys(dept).length > 0 && Object.keys(status).length > 0) {
                  return false
                } else
                  return true
              }



            return true
          }
        }

      },
      fnSetDate(){
        this.deptChanged = false
        this.statusChanged = false
        this.serviceTypeChanged = false
        this.quoteTypeChanged = false
        this.regionChanged = false
        this.storesChanged = false
        this.repChanged = false
        this.originatorChanged = false
        this.vendorChanged = false
        this.customerChanged = false
        this.customerClickChanged = false
        this.roleChanged = false

        this.fncReloadFilters();
      },
      fncReloadFilters() {
        this.$store.commit('fncSummaryFilterLoad', true);
        this.fncShowFilterSlideSub();


      },
      fncFormatDate(date)
      {
        const inputDate = new Date(date);

        // Extract year, month, and day
        const year = inputDate.getFullYear();
        const month = inputDate.getMonth() + 1; // Adding 1 because getMonth() returns zero-based month (0-11)
        const day = inputDate.getDate();

        // Construct the date string in the format 'YYYY-MM-DD'
        return  `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} `;
      },
      setModeDate(){
        this.fncReloadFilters()
      },
      fncShowFilterSlide() {

        // what we need to do here is to duplicate the current local storages and make sure that we can revert when cancelled
        // var cancelVendor = ['all'];
        // if( window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null ) {
        //   cancelVendor = window.localStorage.reportVendors;
        //   localStorage.setItem('cancelVendor', cancelVendor);
        // } else {
        //   localStorage.removeItem('cancelVendor');
        // }
        //
        // var cancelStore = ['all'];
        // if( window.localStorage.reportStores != undefined && window.localStorage.reportStores != null ) {
        //   cancelStore = window.localStorage.reportStores;
        //   localStorage.setItem('cancelStore', cancelStore);
        // } else {
        //   localStorage.removeItem('cancelStore');
        // }
        //
        // var cancelDepartment = ['all'];
        // if( window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null ) {
        //   cancelDepartment = window.localStorage.reportDepartments;
        //   localStorage.setItem('cancelDepartment', cancelDepartment);
        // } else {
        //   localStorage.removeItem('cancelDepartment');
        // }
        //
        // var cancelOriginator = ['all'];
        // if( window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators != null ) {
        //   cancelOriginator = window.localStorage.reportOriginators;
        //   localStorage.setItem('cancelOriginator', cancelOriginator);
        // } else {
        //   localStorage.removeItem('cancelOriginator');
        // }
        //
        // var cancelCustomer = ['all'];
        // if( window.localStorage.reportUsers != undefined && window.localStorage.reportUsers != null ) {
        //   cancelCustomer = window.localStorage.reportUsers;
        //   localStorage.setItem('cancelCustomer', cancelCustomer);
        // } else {
        //   localStorage.removeItem('cancelCustomer');
        // }
        //
        // var cancelStatus = ['all'];
        // if( window.localStorage.reportStatus != undefined && window.localStorage.reportStatus != null ) {
        //   cancelStatus = window.localStorage.reportStatus;
        //   localStorage.setItem('cancelStatus', cancelStatus);
        // } else {
        //   localStorage.removeItem('cancelStatus');
        // }
        //
        // var cancelKam = ['all'];
        // if( window.localStorage.reportKams != undefined && window.localStorage.reportKams != null ) {
        //   cancelKam = window.localStorage.cancelKam;
        //   localStorage.setItem('cancelKam', cancelKam);
        // } else {
        //   localStorage.removeItem('cancelKam');
        // }
        //
        // var cancelQuoteType = ['all'];
        // if( window.localStorage.reportQuoteType != undefined && window.localStorage.reportQuoteType != null ) {
        //   cancelQuoteType = window.localStorage.cancelQuoteType;
        //   localStorage.setItem('cancelQuoteType', cancelQuoteType);
        // } else {
        //   localStorage.removeItem('cancelQuoteType');
        // }
        //
        // var cancelServiceType = ['all'];
        // if( window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null ) {
        //   cancelServiceType = window.localStorage.cancelServiceType;
        //   localStorage.setItem('cancelServiceType', cancelServiceType);
        // } else {
        //   localStorage.removeItem('cancelServiceType');
        // }
        //
        // var cancelProjects = ['all'];
        // if( window.localStorage.reportProjects != undefined && window.localStorage.reportProjects != null ) {
        //   cancelProjects = window.localStorage.cancelProjects;
        //   localStorage.setItem('cancelProjects', cancelProjects);
        // } else {
        //   localStorage.removeItem('cancelProjects');
        // }
        //
        // var cancelCompany = ['all'];
        // if( window.localStorage.reportCompany != undefined && window.localStorage.reportCompany != null ) {
        //   cancelCompany = window.localStorage.cancelCompany;
        //   localStorage.setItem('cancelCompany', cancelCompany);
        // } else {
        //   localStorage.removeItem('cancelCompany');
        // }
        //
        // var cancelcOriginator = ['all'];
        // if( window.localStorage.reportcOriginator != undefined && window.localStorage.reportcOriginator != null ) {
        //   cancelcOriginator = window.localStorage.cancelKam;
        //   localStorage.setItem('cancelcOriginator', cancelcOriginator);
        // } else {
        //   localStorage.removeItem('cancelcOriginator');
        // }
        //
        // var cancelReportDate = [];
        // if( window.localStorage.reportDates != undefined && window.localStorage.reportDates != null ) {
        //   cancelReportDate = window.localStorage.reportDates;
        //   localStorage.setItem('cancelReportDate', cancelReportDate);
        // } else {
        //   localStorage.removeItem('cancelReportDate');
        // }
        //
        // var cancelQuoteSetDays = 0;
        // if( window.localStorage.quoteSetDays != undefined && window.localStorage.quoteSetDays != null ) {
        //   cancelQuoteSetDays = window.localStorage.quoteSetDays;
        //   localStorage.setItem('cancelQuoteSetDays', cancelQuoteSetDays);
        // } else {
        //   // localStorage.setItem('cancelQuoteSetDays', cancelQuoteSetDays);
        //   localStorage.removeItem('cancelQuoteSetDays');
        // }
        //
        // var cancelRegions = ['all'];
        // if( window.localStorage.reportRegions != undefined && window.localStorage.reportRegions != null ) {
        //   cancelRegions = window.localStorage.reportRegions;
        //   localStorage.setItem('cancelRegions', cancelRegions);
        // } else {
        //   localStorage.removeItem('cancelRegions');
        // }
        //
        // var cancelReps = ['all'];
        // if( window.localStorage.reportReps != undefined && window.localStorage.reportReps != null ) {
        //   cancelReps = window.localStorage.reportReps;
        //   localStorage.setItem('cancelReps', cancelReps);
        // } else {
        //   localStorage.removeItem('cancelReps');
        // }

        let report_dates_start = this.fncFormatDate(this.startDate_summary)
        let report_dates_end  = this .fncFormatDate(this.endDate_summary)


          this.$store.dispatch({
            type: 'fncPopulateDashboardCopy',
            date_from: report_dates_start,
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            customer: this.objCustomerUser,
            store: this.objStore,
            department: this.obj_Departments,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
            vendor: this.objVendor,
            project: 'null',
            company: this.objCompany,
            specifier: 'null',
            refresh: true,
            start_date: report_dates_start,
            end_date: report_dates_end,
            ignoreFilters: true,
            filter_only: true,
            search: this.search,
            quoteRegion: this.objRegion,
            quoteRep: this.objRep
          })

      },
      userExists(arr, id) {
        return arr.some(function(el) {
          return el.id == id;
        });
      },
      statusExists(arr, name) {
        return arr.some(function(el) {
          return el.name === name;
        });
      },
      fncShowFilterSlideSub() {
      
      
        let report_dates_start = this.fncFormatDate(this.startDate_summary)
        let report_dates_end   = this .fncFormatDate(this.endDate_summary)

        // console.log(this.monthDiff(new Date(report_dates_start), new Date(report_dates_end)))
        // if (this.monthDiff(report_dates_start, report_dates_end) <= 12){

          localStorage.setItem('summary_report_start_date', this.startDate_summary)
          localStorage.setItem('summary_report_end_date', this.endDate_summary)
          this.$store.dispatch({
            type: 'fncPopulateDashboardCopy',
            date_from: 'null',
            date_to: report_dates_end,
            region: 'null',
            status: this.objStatus,
            role: this.role,
            originator: this.objOriginator,
            customer: this.objCustomerUser,
            department: this.obj_Departments,
            store: this.objStore,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
            vendor: this.objVendor,
            project: 'null',
            company: this.objCompany,
            specifier: 'null',
            refresh: true,
            start_date: report_dates_start,
            end_date: report_dates_end,
            ignoreFilters: true,
            filter_only: true,
            search: this.search,
            quoteRegion:  this.objRegion,
            quoteRep: this.objRep,
            call: 'summary_report',
            report_type: this.value,

          })
        // }
        // else {
        //   alert('Date range should not be greater than 12 months')
        // }


      },
      fncCheckRefresh(type){
        if( type == 'status' ) {
          if (this.$refs.statusSelect != undefined && this.$refs.statusSelect.click === true && Object.keys(this.newReportFilters.status).length !== this.getallFilters.filters.status[0].status ) {
            return true;
          } else {
            return false;
          }
        }
      },
      fncCheckDone( type ) {
        if( type == 'vendor' ) {
          if( this.$refs.vendorSelect !=  undefined && this.$refs.vendorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'status' ) {
          if( this.$refs.statusSelect !=  undefined && this.$refs.statusSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        }
        else if( type == 'role' ) {
          if( this.$refs.roleSelect !=  undefined && this.$refs.roleSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'customer' ) {
          if( this.$refs.customerSelect !=  undefined && this.$refs.customerSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'originator' ) {
          if( this.$refs.originatorSelect !=  undefined && this.$refs.originatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'store' ) {
          if( this.$refs.storeSelect !=  undefined && this.$refs.storeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'department' ) {
          if( this.$refs.departmentSelect !=  undefined && this.$refs.departmentSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'region' ) {
          if( this.$refs.regionSelect !=  undefined && this.$refs.regionSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'rep' ) {
          if( this.$refs.repSelect !=  undefined && this.$refs.repSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'kam' ) {
          if( this.$refs.kamSelect !=  undefined && this.$refs.kamSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'cOriginator' ) {
          if( this.$refs.cOriginatorSelect !=  undefined && this.$refs.cOriginatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'quote_type' ) {
          if( this.$refs.quoteTypeSelect !=  undefined && this.$refs.quoteTypeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'service_type' ) {
          if( this.$refs.serviceTypeSelect !=  undefined && this.$refs.serviceTypeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'projects' ) {
          if( this.$refs.projectsSelect !=  undefined && this.$refs.projectsSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'company' ) {
          if( this.$refs.companySelect !=  undefined && this.$refs.companySelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        }
      },
      fncValidateDateRange(e){
        console.log(e)
      },
      fncCheckDropdownsAllCheck(type){
        this.regenFalse = false;
        var newFilter = [];
        var isAll = false;
        var addedObj = false;
        if( type == 'department' ) {
          for( var v in this.obj_Departments ) {
            if( this.obj_Departments[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.obj_Departments[this.obj_Departments.length -1];
          if( isAll == true && this.obj_Departments.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.obj_Departments ) {
              if (this.obj_Departments[v] != 'all') {
                newFilter.push(this.obj_Departments[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.obj_Departments = newFilter;
        }
        else if( type == 'vendor' ) {
          for( var v in this.objVendor ) {
            if( this.objVendor[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objVendor[this.objVendor.length -1];
          if( isAll == true && this.objVendor.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.objVendor ) {
              if (this.objVendor[v] != 'all') {
                newFilter.push(this.objVendor[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objVendor = newFilter;
        }
        else if( type == 'service_type' ) {
          for( var c in this.objServiceType ) {
            if( this.objServiceType[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objServiceType[this.objServiceType.length -1];
          if( isAll == true && this.objServiceType.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objServiceType ) {
              if (this.objServiceType[c] != 'all') {
                newFilter.push(this.objServiceType[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objServiceType = newFilter;
        }
        else if( type == 'status' ) {
          for( var s in this.objStatus ) {
            if( this.objStatus[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objStatus[this.objStatus.length -1];
          if( isAll == true && this.objStatus.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objStatus ) {
              if (this.objStatus[s] != 'all') {
                newFilter.push(this.objStatus[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objStatus = newFilter;
        }
        else if( type == 'region' ) {
          for( var s in this.objRegion ) {
            if( this.objRegion[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objRegion[this.objRegion.length -1];
          if( isAll == true && this.objRegion.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objRegion ) {
              if (this.objRegion[s] != 'all') {
                newFilter.push(this.objRegion[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objRegion = newFilter;
        }
        else if( type == 'rep' ) {
          for( var s in this.objRep ) {
            if( this.objRep[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objRep[this.objRep.length -1];
          if( isAll == true && this.objRep.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objRep ) {
              if (this.objRep[s] != 'all') {
                newFilter.push(this.objRep[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objRep = newFilter;
        }
        else if( type == 'quote_type' ) {
          for( var c in this.objQuoteType ) {
            if( this.objQuoteType[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objQuoteType[this.objQuoteType.length -1];
          if( isAll == true && this.objQuoteType.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objQuoteType ) {
              if (this.objQuoteType[c] != 'all') {
                newFilter.push(this.objQuoteType[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objQuoteType = newFilter;
        }
        else if( type == 'store' ) {
          for( var s in this.objStore ) {
            if( this.objStore[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objStore[this.objStore.length -1];
          if( isAll == true && this.objStore.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objStore ) {
              if (this.objStore[s] != 'all') {
                newFilter.push(this.objStore[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objStore = newFilter;
        }
        else if( type == 'originator' ) {

          this.hideOriginatorLabels = true;

          for( var o in this.objOriginator ) {
            if( this.objOriginator[o] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objOriginator[this.objOriginator.length -1];
          if( isAll == true && this.objOriginator.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var o in this.objOriginator ) {
              if (this.objOriginator[o] != 'all') {
                newFilter.push(this.objOriginator[o]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objOriginator = newFilter;
        }
        else if( type == 'customer' ) {
          for( var c in this.objCustomerUser ) {
            if( this.objCustomerUser[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objCustomerUser[this.objCustomerUser.length -1];
          if( isAll == true && this.objCustomerUser.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objCustomerUser ) {
              if (this.objCustomerUser[c] != 'all') {
                newFilter.push(this.objCustomerUser[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objCustomerUser = newFilter;
        }
        else if( type == 'roles' ) {
          for( var v in this.role ) {
            if( this.role[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.role[this.role.length -1];
          if( isAll == true && this.role.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.role ) {
              if (this.role[v] != 'all') {
                newFilter.push(this.role[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.role = newFilter;
        }

      },
      fncCheckDropdowns(type, event) {
        this.regenFalse = false;



        var newFilter = [];
        var isAll = false;
        var addedObj = false;

        if( type === 'department' ) {
          let new_value = []
          new_value = event

           let length =  JSON.stringify(new_value)


          let here = false
          if(  new_value.includes('all') && ! this.obj_Departments.includes('all') )
          {
            this.obj_Departments = [];
            this.obj_Departments.push('all');
            this.deptChanged = false
            for( var d in this.newReportFilters.department ) {
              this.obj_Departments.push( d );
              here = true
            }

          }
          else  {

            var newFilters = [];
            let loop = false
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                loop = true
                count ++
              }
            }

            if(  this.obj_Departments.includes('all') && ! newFilters.includes('all') && count == Object.keys(this.newReportFilters.department).length  )
            {
              this.obj_Departments = []
              this.deptChanged = false
            }
            else{
              this.deptChanged = true
              this.obj_Departments = newFilters
            }
          }

          this.prevDept = this.obj_Departments
        }
        if( type === 'roles' ) {
          let new_value = []
          new_value = event
           let length =  JSON.stringify(new_value)


          let here = false
          if(  new_value.includes('all') && ! this.role.includes('all') )
          {
            this.role = [];
            this.role.push('all');
            this.roleChanged= false
            for( var d in this.newReportFilters.roles ) {
              this.role.push( d );
              here = true
            }

          }
          else  {

            var newFilters = [];
            let loop = false
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                loop = true
                count ++
              }
            }

            if(  this.role.includes('all') && ! newFilters.includes('all') && count == Object.keys(this.newReportFilters.roles).length  )
            {
              this.role = [],
                this.roleChanged= false
            }
            else{
              this.roleChanged= true
              this.role = newFilters
            }
          }
        }
        else if (type == 'category'){

          let new_value = []
          new_value = event

          if(  new_value.includes('all') && ! this.objCategory.includes('all') )
          {
            this.objCategory = [];
            //this.objCategory.push('all');
            for( var d in this.category ) {
              if (this.category[d].hasOwnProperty('id'))
                this.objCategory.push( this.category[d].id);
            }

          }
          else  {
            var newFilters = [];
            let loop = false
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                loop = true
                count ++
              }
            }

            if(  this.objCategory.length === this.category.length  && !new_value.includes('all')  )
            {
              this.objCategory = []
            }
            else
              this.objCategory = newFilters
          }
        }

        else if( type == 'vendor' ) {
          let new_value = []
          new_value = event

          if(  new_value.includes('all') && ! this.objVendor.includes('all') )
          {
            this.objVendor = [];
            this.objVendor.push('all');
            this.vendorChanged= false
            for( var d in this.newReportFilters.vendor ) {
              this.objVendor.push( d  );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objVendor.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.vendor).length  )
            {
              this.objVendor = []
              this.vendorChanged= false
            }
            else{
              this.objVendor = newFilters
              this.vendorChanged= true
            }
          }

        }
        else if( type == 'store' ) {

          let new_value = []
          new_value = event
          let here = false
          if(  new_value.includes('all') && ! this.objStore.includes('all') )
          {
            this.objStore = [];
            this.objStore.push('all');
            this.storesChanged = false
            for( var d in this.newReportFilters.store ) {
              this.objStore.push( d );
              here = true
            }

          }
          else  {
            var newFilters = [];
            let loop = false
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                loop = true
                count ++
              }
            }

            if(  this.objStore.includes('all') && ! newFilters.includes('all') && count == Object.keys(this.newReportFilters.store).length  )
            {
              this.objStore = []
              this.storesChanged = false
            }
            else
            {
              this.storesChanged = true
              this.objStore = newFilters
            }
          }


        }
        else if( type == 'originator' ) {


          let new_value = []
          new_value = event

          if(  new_value.includes('all') && ! this.objOriginator.includes('all') )
          {
            this.objOriginator = [];
            this.objOriginator.push('all');
            this.originatorChanged = false
            for( var d in this.newReportFilters.originator ) {
              this.objOriginator.push( d  );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objOriginator.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.originator).length  )
            {
              this.objOriginator = []
              this.originatorChanged = false
            }
            else
            {
              this.objOriginator = newFilters
              this.originatorChanged = true
            }

          }

        }
        else if( type == 'customer' ) {

          let new_value = []
          new_value = event


          let here = false
          if(  new_value.includes('all') && ! this.objCustomerUser.includes('all') )
          {
            this.objCustomerUser = [];
            this.objCustomerUser.push('all');
             this.customerChanged= false
            for( var d in this.newReportFilters.customer ) {
              this.objCustomerUser.push( d );
              here = true
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objCustomerUser.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.customer).length  )
            {
              this.objCustomerUser = []
               this.customerChanged= false
            }
            else
            {
              this.customerChanged= true
              this.objCustomerUser = newFilters
            }

          }
        }
        else if( type == 'status' ) {

          let new_value = []
          new_value = event

          if(  new_value.includes('all') && ! this.objStatus.includes('all') )
          {
            this.objStatus = [];
            this.objStatus.push('all');
            this.statusChanged = false
            for( var d in this.newReportFilters.status ) {
              this.objStatus.push( d );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objStatus.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.status).length  )
            {
              this.objStatus = []
              this.statusChanged = false
            }
            else{
              this.statusChanged = true
              this.objStatus = newFilters
            }
          }


        }
        else if( type == 'region' ) {
          let new_value = []
          new_value = event

          if(  new_value.includes('all') && ! this.objRegion.includes('all') )
          {
            this.objRegion = [];
            this.objRegion.push('all');
            this.regionChanged= false
            for( var d in this.newReportFilters.regions ) {
              this.objRegion.push( d );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push( new_value[d] );
                count ++
              }
            }

            if(  this.objRegion.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.regions).length  )
            {
              this.objRegion = []
              this.regionChanged= false
            }
            else{
              this.objRegion = newFilters
              this.regionChanged= true
            }
          }

        }
        else if( type == 'rep' ) {
          this.hideOriginatorLabels = true;

          let new_value = []
          new_value = event

          if(  new_value.includes('all') && ! this.objRep.includes('all') )
          {
            this.objRep = [];
            this.objRep.push('all');
            this.repChanged= false
            for( var d in this.newReportFilters.reps ) {
              this.objRep.push( d  );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objRep.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.reps).length  )
            {
              this.objRep = []
              this.repChanged= false
            }
            else{
              this.objRep = newFilters
              this.repChanged= true
            }

          }
        }
        else if( type == 'kam' ) {
          for( var c in this.objKam ) {
            if( this.objKam[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objKam[this.objKam.length -1];
          if( isAll == true && this.objKam.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objKam ) {
              if (this.objKam[c] != 'all') {
                newFilter.push(this.objKam[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objKam = newFilter;
        }
        else if( type == 'cOriginator' ) {
          for( var c in this.objcOriginator ) {
            if( this.objcOriginator[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objcOriginator[this.objcOriginator.length -1];
          if( isAll == true && this.objcOriginator.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objcOriginator ) {
              if (this.objcOriginator[c] != 'all') {
                newFilter.push(this.objcOriginator[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objcOriginator = newFilter;
        }
        else if( type == 'quote_type' ) {
          let new_value = []
          new_value = event

          let here = false
          if(  new_value.includes('all') && ! this.objQuoteType.includes('all') )
          {
            this.objQuoteType = [];
            this.objQuoteType.push('all');
            this.quoteTypeChanged= false
            for( var d in this.newReportFilters.quote_type ) {
              this.objQuoteType.push( d  );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objQuoteType.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.quote_type).length  )
            {
              this.objQuoteType = []
              this.quoteTypeChanged= false
            }
            else
            {
              this.quoteTypeChanged= false
              this.objQuoteType = newFilters
            }

          }

        }
        else if( type == 'service_type' ) {
          let new_value = []
          this.serviceTypeChanged = true
          new_value = event

          if(  new_value.includes('all') && ! this.objServiceType.includes('all') )
          {
            this.objServiceType = [];
            this.objServiceType.push('all');
            this.serviceTypeChanged= false
            for( var d in this.newReportFilters.service_type ) {
              this.objServiceType.push( d  );
            }

          }
          else  {
            var newFilters = [];
            let count = 0
            for (var d in new_value) {
              if (new_value[d] != 'all') {
                newFilters.push(new_value[d]);
                count ++
              }
            }

            if(  this.objServiceType.includes('all') && ! newFilters.includes('all') && count === Object.keys(this.newReportFilters.service_type).length  )
            {
              this.objServiceType = []
              this.serviceTypeChanged= false
            }
            else
            {
              this.serviceTypeChanged= true
              this.objServiceType = newFilters
            }

          }
        }
        else if( type == 'projects' ) {
          for( var c in this.objProjects ) {
            if( this.objProjects[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objProjects[this.objProjects.length -1];
          if( isAll == true && this.objProjects.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objProjects ) {
              if (this.objProjects[c] != 'all') {
                newFilter.push(this.objProjects[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objProjects = newFilter;
        }
        else if( type == 'company' ) {
          for( var c in this.objCompany ) {
            if( this.objCompany[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objCompany[this.objCompany.length -1];
          if( isAll == true && this.objCompany.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objCompany ) {
              if (this.objCompany[c] != 'all') {
                newFilter.push(this.objCompany[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objCompany = newFilter;
        }
        // this.fncReloadFilters();
      },
      fncSetFiltersSummary(type ) {

        var toReturn = [{ id: 'all', name: 'All' }];
        var filters = this.newReportFilters;

        if( type == 'vendor' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var v in filters.vendor ) {
            if( this.objVendor.indexOf(String(v)) != -1 ) {
              isSelected.push({id: v, name: filters.vendor[v]})
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var v in filters.vendor ) {
            if( this.objVendor.indexOf(String(v)) == -1 ) {
              isNotSelected.push({id: v, name: filters.vendor[v]})
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }
        if( type == 'roles' ) {
          var isSelected = [];
          var isNotSelected = [];
          let siNotPart = []
          for( var v in filters.roles ) {
            if( this.role.indexOf(String(v)) != -1 ) {
              isSelected.push({id: v, name: filters.roles[v]})
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var v in filters.roles ) {
            if( this.role.indexOf(String(v)) == -1 ) {
              isNotSelected.push({id: v, name: filters.roles[v]})
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in this.getallFilters.filters.role ) {
            if (this.getallFilters.filters.role[d].hasOwnProperty('name')){
              if (! this.userExists(isNotSelected, this.getallFilters.filters.role[d].role)  && ! this.userExists(isSelected, this.getallFilters.filters.role[d].role) ){
                siNotPart.push({ id: this.getallFilters.filters.role[d].role, name: this.getallFilters.filters.role[d].name,disable: true })
              }
            }
          }
          siNotPart.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
          toReturn = toReturn.concat(siNotPart);
        }
        else if( type == 'store' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var s in filters.store ) {
            if( this.objStore.indexOf(String(s)) != -1 ) {
              isSelected.push({id: s, name: filters.store[s]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var s in filters.store ) {
            if( this.objStore.indexOf(String(s)) == -1 ) {
              isNotSelected.push({id: s, name: filters.store[s]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));


          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);

        }
        else if( type == 'status' ) {

          /* if( this.departmentList.length > 0 ) {

            var simpleDepartmentList = [];
            for( var d in this.departmentList ) {
              simpleDepartmentList[this.departmentList[d].id] = this.departmentList[d].name;
            }

            var depStatuses = [];
            //depStatuses[0] = 'No Department Assigned';
            for( var s in this.statusList ) {
              for( var fs in filters.status ) {
                if( this.statusList[s].description == fs  ) {
                  if( depStatuses[this.statusList[s].department] == null ) {
                    depStatuses[this.statusList[s].department] = [];
                  }
                  depStatuses[this.statusList[s].department].push( this.statusList[s] );
                }
              }
            }

            var isSelected = [];

            for( var ds in depStatuses ) {
              if( ds == 0 ) {
                isSelected.push({header: 'No Department Assigned'});
              } else {
                isSelected.push({header: simpleDepartmentList[ds]});
              }
              for( var dss in depStatuses[ds] ) {
                isSelected.push({id: depStatuses[ds][dss].description, name: depStatuses[ds][dss].description});
              }
            }

            toReturn = toReturn.concat(isSelected);

          } else { */
          var isSelected = [];
          var isNotSelected = [];
          let siNotPart = []
          for( var s in filters.status ) {
            if( this.objStatus.indexOf(String(s)) != -1 ) {
              isSelected.push({id: s, name: s, disable: false});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var s in filters.status ) {
            if( this.objStatus.indexOf(String(s)) == -1 ) {
              isNotSelected.push({id: s, name: s, disable: false});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));

          for( var d in this.getallFilters.filters.status ) {
            if (this.getallFilters.filters.status[d].hasOwnProperty('description')){
              if (! this.statusExists(isNotSelected, this.getallFilters.filters.status[d].description)  && ! this.statusExists(isSelected, this.getallFilters.filters.status[d].description) ){
                siNotPart.push({ id: this.getallFilters.filters.status[d].status, name: this.getallFilters.filters.status[d].description,disable: true })
              }
            }
          }
          siNotPart.sort((a, b) => a.name.localeCompare(b.name));

          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
          toReturn = toReturn.concat(siNotPart);
          // }
        }
        else if( type == 'originator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }
        else if( type == 'customer' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) != -1 ) {
              isSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) == -1 ) {
              isNotSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }
        else if( type == 'department' ) {
          var isSelected = [];
          var isNotSelected = [];
          let siNotPart = []

          for( var d in filters.department ) {
           if( this.obj_Departments.indexOf(String(d)) != -1 ) {
              isSelected.push({ id: d, name: filters.department[d], disable: false });
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.department ) {
            if( this.obj_Departments.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: d, name: filters.department[d] , disable: false});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));

          for( var d in this.getallFilters.filters.dept ) {
            if (this.getallFilters.filters.dept[d].hasOwnProperty('name')){
              if (! this.userExists(isNotSelected, this.getallFilters.filters.dept[d].department)  && ! this.userExists(isSelected, this.getallFilters.filters.dept[d].department) ){
                siNotPart.push({ id: this.getallFilters.filters.dept[d].department, name: this.getallFilters.filters.dept[d].name,disable: true })
              }
            }
          }
          siNotPart.sort((a, b) => a.name.localeCompare(b.name));


          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
          toReturn = toReturn.concat(siNotPart);
        }
        else if( type == 'region' ) {

          var isSelected = [];
          var isNotSelected = [];
          let siNotPart = []
          for( var d in filters.regions ) {
            if (this.objRegion.indexOf(String(d)) != -1) {
              isSelected.push({ id: d, name: filters.regions[d], disable: false});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.regions ) {
            if( this.objRegion.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: d, name: filters.regions[d] , disable: false});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in this.getallFilters.filters.region ) {
            if (this.getallFilters.filters.region[d].hasOwnProperty('name')){
              if (! this.userExists(isNotSelected, this.getallFilters.filters.region[d].region)  && ! this.userExists(isSelected, this.getallFilters.filters.region[d].region) ){
                siNotPart.push({ id: this.getallFilters.filters.region[d].region, name: this.getallFilters.filters.region[d].name,disable: true })
              }
            }
          }
          siNotPart.sort((a, b) => a.name.localeCompare(b.name));

          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
          toReturn = toReturn.concat(siNotPart);

        } else if( type == 'rep' ) {
          var isSelected = [];
          var isNotSelected = [];
          for (var d in filters.reps) {
            if (this.objRep.indexOf(String(d)) != -1) {
              isSelected.push({id: d, name: filters.reps[d]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for (var d in filters.reps) {
            if (this.objRep.indexOf(String(d)) == -1) {
              isNotSelected.push({id: d, name: filters.reps[d]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'kam' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.commercial_kam ) {
            if( this.objKam.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.commercial_kam[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.commercial_kam ) {
            if( this.objKam.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.commercial_kam[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'cOriginator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.commercial_originator ) {
            if( this.objcOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.commercial_originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.commercial_originator ) {
            if( this.objcOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.commercial_originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }
        else if( type == 'quote_type' ) {

          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.quote_type ) {
            if( this.objQuoteType.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.quote_type[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.quote_type ) {
            if( this.objQuoteType.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.quote_type[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'service_type' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.service_type ) {
            if( this.objServiceType.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.service_type[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.service_type ) {
            if( this.objServiceType.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.service_type[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'projects' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.projects ) {
            if( this.objProjects.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.projects[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.projects ) {
            if( this.objProjects.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.projects[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'company' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.companies ) {
            if( this.objCompany.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.companies[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.companies ) {
            if( this.objCompany.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.companies[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }

        return toReturn;

      },
	    fncHideModal() {
        //this.$store.commit('fncSetQuoteReportLoaded', true);
	      this.$store.commit('hideModal');
      },
      fncCheckAllRoles() {
        if(  this.role.includes('all') && this.objRoles.length !== this.role.length ) {
          this.role = [];
          this.role.push('all');
          for( var d in this.objRoles ) {
            this.role.push( this.objRoles[d].id );
          }
        }
        else
        {
          var newFilters = [];
          for( var d in this.role ) {
            if(this.role[d] != 'all') {
              newFilters.push(this.role[d]);
            }
          }
          if( newFilters.length === ( this.objRoles.length - 1 ))
          {
            this.role = [];
          }
          else
          {
            this.role = newFilters;
          }
        }

      },
      fncGenerateSummaryReport() {
        this.$store.commit('fncSummaryFilterLoad', true);

        let tem_dept = this.obj_Departments.filter(element => element !== 'all')
        let newDepartments = (tem_dept.length > 0) ? tem_dept : Object.keys(this.newReportFilters.department);

        let tem_status = this.objStatus.filter(element => element !== 'all')
        let newStatus = (tem_status !== undefined && tem_status.length > 0) ? tem_status : this.newReportFilters.status;

        let tem_role = this.role.filter(element => element !== 'all')
        let newRole = (tem_role.length > 0) ? tem_role : Object.keys(this.newReportFilters.roles);

        let start = new Date(this.startDate_summary.getTime() - (this.startDate_summary.getTimezoneOffset() * 60000 ))
          .toISOString()
          .split("T")[0];
        let end = new Date(this.endDate_summary.getTime() - (this.endDate_summary.getTimezoneOffset() * 60000 ))
          .toISOString()
          .split("T")[0];

        this.$store.dispatch({
          type: 'fncGenerateSummaryReport',
          start_date: start,
          end_date: end,
          departments: newDepartments,
          status: newStatus,
          role: newRole,
          call: 'summary_report'
        });
        this.drawer = false
      },
	    fncGenerate(type, report_type) {
        this.$store.commit('fncSummaryFilterLoad', true);

        if (this.objStore != '' && this.objStore[0] != 'all') {
          localStorage.setItem('summaryReportStore', JSON.stringify( this.objStore))
        } else {
          localStorage.removeItem('summaryReportStore');
        }
        if (this.status != '' && this.status[0] != 'all') {
          localStorage.setItem('summary_status', JSON.stringify(this.status))
        } else {
          localStorage.removeItem('summary_status');
        }
        if (this.role != '' && this.role[0] != 'all') {
          localStorage.setItem('summaryReportRoles', JSON.stringify(this.role))
        } else {
          localStorage.removeItem('summaryReportRoles');
        }
        if (this.obj_Departments != '' && this.obj_Departments[0] != 'all') {
          localStorage.setItem('summaryReportDepartments', JSON.stringify( this.obj_Departments))
        } else {
          localStorage.removeItem('summaryReportDepartments');
        }
        if (this.objCategory != '' && this.objCategory[0] != 'all') {
          localStorage.setItem('summaryReportCategory', JSON.stringify( this.objCategory))
        } else {
          localStorage.removeItem('summaryReportCategory');
        }
        if (this.objStatus != '' && this.objStatus[0] != 'all') {
          localStorage.setItem('summaryReportStatus', JSON.stringify( this.objStatus))
        } else {
          localStorage.removeItem('summaryReportStatus');
        }
        if (this.objCustomerRegion != '' && this.objCustomerRegion[0] != 'all') {
          localStorage.setItem('summaryReportRegion', JSON.stringify( this.objCustomerRegion))
        } else {
          localStorage.removeItem('summaryReportRegion');
        }
        if (this.objCustomerRegion != '' && this.objCustomerRegion[0] != 'all') {
          localStorage.setItem('summaryReportRegion', JSON.stringify( this.objCustomerRegion))
        } else {
          localStorage.removeItem('summaryReportRegion');
        }
        if (this.objOriginator != '' && this.objOriginator[0] != 'all') {
          localStorage.setItem('summaryReporteportOriginators', JSON.stringify( this.objOriginator))
        } else {
          localStorage.removeItem('summaryReporteportOriginators');
        }
        if (this.objKam != '' && this.objKam[0] != 'all') {
          localStorage.setItem('summaryReportKams', JSON.stringify( this.objKam))
        } else {
          localStorage.removeItem('summaryReportKams');
        }
        if (this.objQuoteType != '' && this.objQuoteType[0] != 'all') {
          localStorage.setItem('summaryReportQuoteType', JSON.stringify( this.objQuoteType))
        } else {
          localStorage.removeItem('summaryReportQuoteType');
        }
        if (this.objRegion != '' && this.objRegion[0] != 'all') {
          localStorage.setItem('summaryReportRegion', JSON.stringify( this.objRegion))
        } else {
          localStorage.removeItem('summaryReportRegion');
        }
        if (this.objRep != '' && this.objRep[0] != 'all') {
          localStorage.setItem('summaryReportRep', JSON.stringify( this.objRep))
        } else {
          localStorage.removeItem('summaryReportRep');
        }
        if (this.objMeasurement != '' && this.objMeasurement[0] != 'all') {
          localStorage.setItem('summaryReportMeasurement', JSON.stringify( this.objMeasurement))
        } else {
          localStorage.removeItem('summaryReportMeasurement');
        }
        if (this.objServiceType != '' && this.objServiceType[0] != 'all') {
          localStorage.setItem('summaryReportServiceType', JSON.stringify( this.objServiceType))
        } else {
          localStorage.removeItem('summaryReportServiceType');
        }
        if (this.objVendor != '' && this.objVendor[0] != 'all') {
          localStorage.setItem('summaryReportVendors', JSON.stringify( this.objVendor))
        } else {
          localStorage.removeItem('summaryReportVendors');
        }
        if (this.objIncrement != '' && this.objIncrement[0] != 'all') {
          localStorage.setItem('summaryReportIncrement', JSON.stringify( this.objIncrement))
        } else {
          localStorage.removeItem('summaryReportIncrement');
        }

        localStorage.setItem('summaryReportReportType', JSON.stringify( this.value))

        var newDepartments = [];
        for( var d in this.department ) {
          if( this.department[d] != 'all' ) {
            newDepartments.push(this.department[d]);
          }
        }

        var newStatus = [];
        for( var s in this.status ) {
          if( this.status[s] != 'All' && this.status[s] != 'all' ) {
            newStatus.push(this.status[s]);
          }
        }

        var newRole = [];
        for( var r in this.role ) {
          if( this.role[r] != 'all' ) {
            newRole.push(this.role[r]);
          }
        }

        let start = new Date(this.startDate_summary.getTime() - (this.startDate_summary.getTimezoneOffset() * 60000 ))
          .toISOString()
          .split("T")[0];
        let end = new Date(this.endDate_summary.getTime() - (this.endDate_summary.getTimezoneOffset() * 60000 ))
          .toISOString()
          .split("T")[0];

        this.$store.dispatch({
          type: 'fncPopulateQuoteListCopy',
          date_from: start,
          date_to: end,
          // region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus,
          originator: this.objOriginator,
          originator_copy:  Object.keys(this.newReportFilters.originator),
          department: this.obj_Departments,
          department_copy:  Object.keys(this.newReportFilters.department),
          vendor: this.objVendor,
          vendor_copy: Object.keys(this.newReportFilters.vendor),
          customer: this.objCustomerUser,
          company: ['all'],
          // company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: 'null',
          store: this.objStore,
          store_copy:  Object.keys(this.newReportFilters.store),
          quoteRegion: this.objRegion,
          quoteRep: this.objRep,
          commercial_kam: this.objKam,
          quote_type: this.objQuoteType,
          service_type: this.objServiceType,
          commercial_originator: this.objcOriginator,
          payloadRefresh: true,
          start_date: start,
          end_date: end,
          call_type: type,
          refresh: true,
          role: this.role,
          role_copy: Object.keys(this.newReportFilters.roles),
          rep_copy: Object.keys(this.newReportFilters.reps),
          quoteRegionCopy: Object.keys(this.newReportFilters.regions),
          report_increment: this.objIncrement,
          report_measurement: this.objMeasurement,
          category: this.objCategory,
          report_type: report_type,
          show_zero: this.show_zero,
        })

        // this.$store.dispatch({
        //   type: 'fncPopulateDashboard',
        //   date_from: 'null',
        //   date_to: end,
        //   region: 'null',
        //   status: this.objStatus,
        //   originator: this.objOriginator,
        //   customer: this.objCustomerUser,
        //   department: this.obj_Departments,
        //   store: this.objStore,
        //   commercial_kam: this.objKam,
        //   commercial_originator: this.objcOriginator,
        //   quote_type: this.objQuoteType,
        //   service_type: this.objServiceType,
        //   projects: this.objProjects,
        //   vendor: this.objVendor,
        //   project: 'null',
        //   company: this.objCompany,
        //   specifier: 'null',
        //   refresh: true,
        //   start_date: start,
        //   end_date: end,
        //   ignoreFilters: true,
        //   search: this.search,
        //   quoteRegion: this.objRegion,
        //   quoteRep: this.objRep,
        //   call_type: type,
        //   role: newRole,
        //   category: this.objCategory,
        // })

	      // this.$store.dispatch({
        //   type: 'fncGenerateSummaryReport',
        //   startDate: start,
        //   endDate: end,
        //   departments: newDepartments,
        //   role: newRole,
        //   status: this.objStatus,
        //   originator: this.objOriginator,
        //   customer: this.objCustomerUser,
        //   department: this.obj_Departments,
        //   store: this.objStore,
        //   commercial_kam: this.objKam,
        //   commercial_originator: this.objcOriginator,
        //   quote_type: this.objQuoteType,
        //   service_type: this.objServiceType,
        //   projects: this.objProjects,
        //   vendor: this.objVendor,
        //   project: [],
        //   company: this.objCompany,
        //   specifier: [],
        //   refresh: true,
        //   search: this.search,
        //   quoteRegion: this.objRegion,
        //   quoteRep: this.objRep,
        //   call_type: type,
        //   report_increment: this.objIncrement,
        //   report_measurement: this.objMeasurement,
        //   category: this.objCategory,
        //   roles: this.role
        // });
      },

		},

    beforeMount() {
      //this.$store.dispatch('fncPopulateDepartments');
      //this.$store.dispatch('fncPopulateStatusList');
      this.$store.dispatch({
        type: 'fncPopulateFiltersList',
      })
      this.$store.commit('fncSummaryFilterLoad', true);

      let start
      let end
      if (localStorage.getItem('summary_report_start_date') != null && localStorage.getItem('summary_report_start_date') !== undefined){
        this.startDate_summary = new Date(localStorage.getItem('summary_report_start_date'))
        start = this.fncFormatDate( localStorage.getItem('summary_report_start_date')) 
       
      }
      else {
        var dToday = new Date();
        this.startDate_summary = new Date(new Date().setDate(dToday.getDate() - 30));
        var quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
        quote_age = quote_age.toISOString().split('T')[0];
        start = quote_age; 
       
      }
      if (localStorage.getItem('summary_report_end_date') != null && localStorage.getItem('summary_report_end_date') !== undefined){
        this.endDate_summary = new Date(localStorage.getItem('summary_report_end_date'));
        end = this.fncFormatDate(localStorage.getItem('summary_report_end_date'))
        
      }
      else {
        dToday = new Date();
        this.endDate_summary = new Date(new Date().setDate(dToday.getDate()));
        quote_age = new Date(new Date().setDate(dToday.getDate()));
        quote_age = quote_age.toISOString().split('T')[0];
        end = quote_age; 
      }

      this.$store.dispatch({
        type: 'fncPopulateDashboardCopy',
        date_from: 'null',
        date_to: 'null',
        region: this.objRegions,
        status: this.objStatus,
        originator: this.objOriginator,
        customer: this.objCustomerUser,
        store: this.objStore,
        commercial_kam: this.objKam,
        commercial_originator: this.objcOriginator,
        quote_type: this.objQuoteType,
        service_type: this.objServiceType,
        project: 'null',
        vendor: this.objVendor,
        company: ['all'],
        specifier: 'null',
        refresh: true,
        start_date: start,
        end_date: end,
        ignoreFilters: true,
        filter_only: true,
        search: this.search,
        quoteRegion: this.objRegion,
        quoteRep: this.objRep,
        department: this.obj_Departments,
        role:this.role,
        report_type: this.value
      })

    },
    mounted() {
      //this.fncReloadFilters()
      // if( this.userRoles.length > 0 ) {
      //   this.objRoles = []
      //
      //   this.objRoles.push({id: 'all', name: 'All'});
      //   var preAlpha = [];
      //   for( var r in this.userRoles ) {
      //     preAlpha.push({id: this.userRoles[r].id, name: this.userRoles[r].name});
      //   }
      //   preAlpha.sort((a, b) => a.name.localeCompare(b.name));
      //   for( var p in preAlpha) {
      //     this.objRoles.push({id: preAlpha[p].id, name: preAlpha[p].name});
      //   }
      //   let l = JSON.parse(localStorage.getItem("summaryReportRoles"));
      //   if (l.length == 0 ) {
      //     this.role =  []
      //     this.role.push('all')
      //     for( var p in preAlpha) {
      //       this.role.push(preAlpha[p].id)
      //     }
      //   }
      //
      // }
      var elements = document.getElementsByClassName("card__title");

      if (this.value){
        this.$store.commit('setGlobalModalTitle', 'SUMMARY REPORTING - BY CONVERSION DATE');
        elements[0].classList.remove('modalTitle');
        elements[0].classList.add('modal-coversion');
      }
      else{
        this.$store.commit('setGlobalModalTitle', 'SUMMARY REPORTING - BY ORIGINATION DATE');
        elements[0].classList.remove('modal-coversion');
        elements[0].classList.add('modalTitle');
      }

      this.objCategory = []
      for (let ca in this.category){
        this.objCategory.push(this.category[ca].id)
      }
	    // if( this.departmentList.length > 0 ) {
      //   // this.objDepartments.push({id: 'all', name: 'All'});
      //   var preAlpha = [];
	    //   for( var d in this.departmentList ) {
      //     preAlpha.push({id: this.departmentList[d].id, name: this.departmentList[d].name});
      //   }
      //   preAlpha.sort((a, b) => a.name.localeCompare(b.name));
      //   for( var p in preAlpha) {
      //     this.objDepartments.push({id: preAlpha[p].id, name: preAlpha[p].name});
      //   }
      // }

      if (localStorage.getItem('summary_department') !== null){
       // this.department = JSON.parse(localStorage.getItem('summary_department'))
      }


    },
    updated() {

      //document.getElementsByClassName('btn__content').className = 'btn__content__overwrite'
      let elementsArray = document.querySelectorAll('.btn__content');

      let dept = 'By\n' + 'Department'
      let store = 'By\n' + 'Region/Store'
      let role = 'By\n' + 'Role'
      let originator = 'By\n' + 'Originator'
      let  vendor = 'By\n' + 'Vendor'
      if (elementsArray.length !== 0){
        for (let i in elementsArray){
          if (dept === elementsArray[i].outerText)
            elementsArray[i].classList.replace('btn__content','btn__content__overwrite')
          else if (store === elementsArray[i].outerText)
            elementsArray[i].classList.replace('btn__content','btn__content__overwrite')
          else if (role === elementsArray[i].outerText)
            elementsArray[i].classList.replace('btn__content','btn__content__overwrite')
          else if (originator === elementsArray[i].outerText)
            elementsArray[i].classList.replace('btn__content','btn__content__overwrite')
          else if (vendor === elementsArray[i].outerText)
            elementsArray[i].classList.replace('btn__content','btn__content__overwrite')
        }
      }
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
        'statusList',
        'userRoles',
        'getSummaryStatusList',
        'getSummaryRoleList',
        'newReportFilters',
        // 'summaryLoading',
        // 'filterNeedsReload',
        // 'quoteReportLoaded',
        'getallFilters',
        'summaryFilterLoad'
			]),
		},
    watch: {
      value(){
        const title =  document.getElementsByClassName("card__title");
        if (this.value){
          this.$store.commit('setGlobalModalTitle', 'SUMMARY REPORTING - BY CONVERSION DATE');
          title[0].classList.remove('modalTitle');
          title[0].classList.add('modal-coversion');
          this.report_type = 2
        }
        else{
          this.$store.commit('setGlobalModalTitle', 'SUMMARY REPORTING - BY ORIGINATION DATE');
          title[0].classList.remove('modal-coversion');
          title[0].classList.add('modalTitle');
          this.report_type = 1
        }
      },
      summaryFilterLoad(){
        if (this.summaryFilterLoad){
          this.loading = true
          this.$forceUpdate();
        }
        else{
          this.loading = false
          this.$forceUpdate();
        }
      },
      startDate_summary(){
        if (this.monthDiff(this.startDate_summary, this.endDate_summary) > 12 )
        {
          this.objIncrement = 2
        }
      },
      endDate_summary(){
        if (this.monthDiff(this.startDate_summary, this.endDate_summary) > 12 )
        {
          this.objIncrement = 2
        }
      },

      objCategory(){
        if ( ! this.objCategory.includes('all') && this.objCategory.length === this.category.length-1){
          this.objCategory = []
          this.objCategory.push('all')
          for (let i in this.category){
            this.objCategory.push(this.category[i].id)
          }
        }
      },
      // objStatus(){
      //   if (this.objStatus.length > 0){
      //     if (this.status.length > 0){
      //
      //       for( let r in this.status ) {
      //         let found  = false
      //         for( let ob in this.objStatus ) {
      //           if (this.status[r] === this.objStatus[ob].name ){
      //             found = true
      //             break
      //           }
      //         }
      //         if (!found){
      //           this.status.splice(r,1)
      //         }
      //       }
      //     }
      //   }
      //
      // },
      // objRoles(){
      //   if (this.objRoles.length > 0){
      //     if (this.role.length > 0){
      //
      //       for( let r in this.role ) {
      //         let found  = false
      //         for( let ob in this.objRoles ) {
      //           if (this.role[r] === this.objRoles[ob].id ){
      //             found = true
      //             break
      //           }
      //         }
      //         if (!found){
      //           this.role.splice(r,1)
      //         }
      //       }
      //
      //     }
      //   }
      // },

      // getSummaryStatusList(){
      //   if( Object.keys(this.getSummaryStatusList).length > 0 ) {
      //     if (localStorage.getItem("summary_status") !== null)
      //       this.status =  JSON.parse(localStorage.getItem('summary_status'))
      //
      //     this.objStatus = []
      //     this.objStatus.push({id: 'all', name: 'All'});
      //     var preAlpha = [];
      //     for( var s in this.getSummaryStatusList ) {
      //       preAlpha.push({id: this.getSummaryStatusList[s].name, name: this.getSummaryStatusList[s].name});
      //     }
      //     //preAlpha.sort((a, b) => a.name.localeCompare(b.name));
      //     for( var p in preAlpha) {
      //       this.objStatus.push({id: preAlpha[p].id, name: preAlpha[p].name});
      //     }
      //   }
      // },

      // getSummaryRoleList(){
      //   if( Object.keys(this.getSummaryRoleList).length > 0 ) {
      //     // if (localStorage.getItem("summary_roles") !== null)
      //     //   this.role =  JSON.parse(localStorage.getItem('summary_roles'))
      //
      //     this.objRoles = []
      //     this.objRoles.push({id: 'all', name: 'All'});
      //     var preAlpha = [];
      //     for( var r in this.getSummaryRoleList ) {
      //       preAlpha.push({id: this.getSummaryRoleList[r].id, name: this.getSummaryRoleList[r].name});
      //     }
      //     preAlpha.sort((a, b) => a.name.localeCompare(b.name));
      //     for( var p in preAlpha) {
      //       this.objRoles.push({id: preAlpha[p].id, name: preAlpha[p].name});
      //     }
      //   }
      // },

   },
    components: {
      DatePicker
    }
	}
</script>

<style >

  #dashDateRep input {
    width: 100% !important;
  }

  .container.summaryReporting.grid-list-xl .layout .flex {
    padding: 0px !important;
  }

  /* Safari and Chrome, if Chrome rule needed */
.selector:not(*:root), .container.grid-list-xl.summaryReporting {
    padding-top: 25px !important;
    padding-bottom: 1px !important;
  }


.select .v-input__control {
  overflow: hidden;
}

#manu_385889803 .summaryReporting .flex.align-end.lg6, #manu_385889803 .summaryReporting .flex.align-center.lg6 {
  text-align: center;
  padding: 0 25px 0 !important;

}
#manu_385889803 #dashDate input {
  color: #333;
}

.summaryReporting .filterDone {
  right: 28px !important;
  top: 25px !important;
}

#manu_385889803 .mx-calendar-month>a.current, #manu_385889803 .mx-calendar-table td.current, #manu_385889803 .mx-calendar-year>a.current {
  background-color: #ffcc00;
}

#manu_385889803 .mx-calendar-month>a:hover, #manu_385889803 .mx-calendar-table td.inrange, #manu_385889803 .mx-calendar-table td:hover, #manu_385889803 .mx-calendar-year>a:hover {
  background-color: #ebebeb;
}

.summaryReporting div#dashDate[data-v-035677ac] {
  min-width: 95% !important;
}

.btn__content__overwrite {
  display: flex;
  flex-direction: column;
  align-items: center !important;
}

.label_tile_top, .label_tile_top_conversion {
  font-weight: 400;
  font-size: 14px;
  text-transform: capitalize !important;
}

.label_tile_bottom, .label_tile_bottom_conversion{
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  text-transform: capitalize !important;
  margin-top: -5px;
}

.second_btton_color{
  background-color: #ffd600 !important;
  min-width: 100px;
  width: 94%;
  height: 100px;
  border-radius: 10px!important;
  pointer-events: all !important;
}

.label_tile_bottom, .label_tile_top {
  color: white;
}

.report_image {
  max-height: 40px;
  margin-bottom: 5px;
}

.input-group.input-group--solo.red_borders{
  border: 3px solid red !important;
}
.input-group.input-group--multiple .input-group__input.red_borders {
  border: 3px solid red !important;
}
.chip .chip__content
{
  height: 20px !important;
}
.flex {
  margin-bottom: -1px !important;
  /* margin-top: -3px !important; */
}
i.grey--text.icon.input-group--append-icon.material-icons {
  font-size: 18px;
  font-weight: 400;
}
i.icon.material-icons.input-group__prepend-icon {
  min-width: 15px !important;
  /* font-weight: 100; */
  font-size: 18px;
}
  .switch-container {
    display: flex;
    align-items: center;
  }

  .left-label {
    margin-top: -24.5px;
    margin-right: 14px;
    font-size: 12px !important;
  }

  .right-label {
    margin-left: 8px;
  }
  .modal-coversion{
    background-color: rgb(255, 214, 0) !important;
    color: black !important;
    font-size: 18px !important;
    /*- background: #a5b6c7; */
    /*background: #646464;*/
    /*background: #017EBA !important;*/
    font-weight: 600 !important;
    padding: 24px !important;
    padding-top: 14px !important;
    padding-bottom: 14px !important;
    text-transform: uppercase !important;
    position: fixed !important;
    width: 95% !important;
    /*width: 900px;*/
    z-index: 99999 !important;
  }

</style>


